/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ContentModuleModal, TextField, CheckboxField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import api from '@api';

import Form from '../Form';

import Item from './Item';
import { FORM_FIELD } from './constants';

const LiveBlog = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues, errors }) => {
  const [form] = Form.useForm();
  const [liveBlogId, setLiveBlogId] = React.useState(initialValues?.id || '');

  React.useEffect(() => {
    if (visible && !initialValues?.id) {
      api.liveBlogs
        .getBlogId()
        .then((res) => res)
        .then((id) => setLiveBlogId(id));
    }
  }, [initialValues, visible, form]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit({ id: liveBlogId, ...values });
    handleClose();
  };

  return (
    <ContentModuleModal
      visible={visible}
      title="Live blog"
      subtitle="Set up a live blog to include on this page"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD LIVE BLOG'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form form={form} layout="vertical" initialValues={initialValues} onFinish={handleSubmit}>
        <TextField {...FORM_FIELD.TITLE} />
        <CheckboxField {...FORM_FIELD.SHOW_TIME_STAMP} style={NO_MARGIN_BOTTOM} />
      </Form>
    </ContentModuleModal>
  );
};

LiveBlog.Item = Item;

export default LiveBlog;
